import { render, staticRenderFns } from "./PrivateMessage.vue?vue&type=template&id=be582ff4&scoped=true"
import script from "./PrivateMessage.vue?vue&type=script&lang=js"
export * from "./PrivateMessage.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessage.vue?vue&type=style&index=0&id=be582ff4&prod&scoped=true&lang=css"
import style1 from "./PrivateMessage.vue?vue&type=style&index=1&id=be582ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be582ff4",
  null
  
)

export default component.exports